"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = startsFromAny;
var _startsWith = _interopRequireDefault(require("lodash/startsWith"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function startsFromAny(string, params) {
  for (var i = 0; i < params.length; i += 1) {
    if ((0, _startsWith["default"])(string, params[i])) {
      return true;
    }
  }
  return false;
}